import React from 'react';

/** Stemmed pub goblet used on Знаменитости Паба. */
export function GobletIcon({ className = '' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <ellipse cx="24" cy="10" rx="14" ry="4" fill="#fff" opacity="0.95" />
      <path
        d="M10 12c0 2 1 4 2.5 5.5C15 20 16 24 16 28c0 5.5 3.5 9 8 9s8-3.5 8-9c0-4 1-8 3.5-10.5C37 16 38 14 38 12"
        fill="var(--badge-foam, #F7F4EE)"
      />
      <path
        d="M14 18c1.5 2 2.2 5 2.2 9 0 4.2 2.6 7 7.8 7s7.8-2.8 7.8-7c0-4 .7-7 2.2-9"
        fill="var(--badge-ale, #D7A35A)"
      />
      <path d="M22 37v4h4v-4" fill="var(--badge-ale, #D7A35A)" />
      <path
        d="M17 43h14c0 2.2-3 3.5-7 3.5s-7-1.3-7-3.5z"
        fill="var(--badge-ale, #D7A35A)"
      />
      <circle cx="18" cy="22" r="1.4" fill="#fff" opacity="0.55" />
      <circle cx="21" cy="26" r="1" fill="#fff" opacity="0.4" />
    </svg>
  );
}

export default GobletIcon;
